import React from 'react';
import { Card, Button, Table, Tag, Space, Avatar } from 'antd';
import { PlusOutlined, SyncOutlined } from '@ant-design/icons';

const AccountManage = () => {
  // 模拟数据
  const dataSource = [
    {
      key: '1',
      nickname: '美食探索者',
      avatar: '',
      followerCount: 128000,
      videoCount: 156,
      groupName: '美食类',
      status: 'active'
    },
    {
      key: '2',
      nickname: '知识分享站',
      avatar: '',
      followerCount: 85000,
      videoCount: 98,
      groupName: '知识类',
      status: 'active'
    }
  ];

  const columns = [
    {
      title: '账号',
      dataIndex: 'nickname',
      key: 'nickname',
      render: (text, record) => (
        <Space>
          <Avatar src={record.avatar} icon={!record.avatar && '👤'} />
          {text}
        </Space>
      )
    },
    {
      title: '粉丝数',
      dataIndex: 'followerCount',
      key: 'followerCount',
      render: (count) => `${(count / 10000).toFixed(1)}w`
    },
    {
      title: '作品数',
      dataIndex: 'videoCount',
      key: 'videoCount'
    },
    {
      title: '分组',
      dataIndex: 'groupName',
      key: 'groupName'
    },
    {
      title: '状态',
      dataIndex: 'status',
      key: 'status',
      render: (status) => {
        const statusMap = {
          active: { color: 'success', text: '正常' },
          inactive: { color: 'default', text: '未激活' },
          banned: { color: 'error', text: '封禁' },
          limited: { color: 'warning', text: '限流' }
        };
        const { color, text } = statusMap[status] || { color: 'default', text: status };
        return <Tag color={color}>{text}</Tag>;
      }
    },
    {
      title: '操作',
      key: 'action',
      render: () => (
        <Space size="small">
          <Button type="link" size="small">编辑</Button>
          <Button type="link" icon={<SyncOutlined />} size="small">同步</Button>
          <Button type="link" danger size="small">解绑</Button>
        </Space>
      )
    }
  ];

  return (
    <div>
      <Card
        title="多账号管理中心"
        extra={
          <Button type="primary" icon={<PlusOutlined />}>
            绑定账号
          </Button>
        }
      >
        <Table
          columns={columns}
          dataSource={dataSource}
          pagination={{ pageSize: 10 }}
        />
      </Card>
    </div>
  );
};

export default AccountManage;
